import React from 'react';
import { styled, Typography } from '@mui/material';

const Root = styled('div')({
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
});

const Message = styled(Typography)({
    fontSize: 18,
    padding: 32
});

const MessageView = (props: { children: any }) => {
    return (
        <Root>
            <Message>{props.children}</Message>
        </Root>
    )
}

export default MessageView;